__turbopack_context__.v({
  "backgroundAsset": "FullBleedCallout-module-scss-module__LnXdeq__backgroundAsset",
  "backgroundLayer": "FullBleedCallout-module-scss-module__LnXdeq__backgroundLayer",
  "blurOverlay": "FullBleedCallout-module-scss-module__LnXdeq__blurOverlay",
  "container": "FullBleedCallout-module-scss-module__LnXdeq__container",
  "fullBleedCallout": "FullBleedCallout-module-scss-module__LnXdeq__fullBleedCallout",
  "fullBleedCallout--linked": "FullBleedCallout-module-scss-module__LnXdeq__fullBleedCallout--linked",
  "headline": "FullBleedCallout-module-scss-module__LnXdeq__headline",
  "headlineText": "FullBleedCallout-module-scss-module__LnXdeq__headlineText",
  "heartIcon": "FullBleedCallout-module-scss-module__LnXdeq__heartIcon",
  "insetImage": "FullBleedCallout-module-scss-module__LnXdeq__insetImage",
  "insetImageWrapper": "FullBleedCallout-module-scss-module__LnXdeq__insetImageWrapper",
  "stack-module-0": "FullBleedCallout-module-scss-module__LnXdeq__stack-module-0",
  "stack-module-1": "FullBleedCallout-module-scss-module__LnXdeq__stack-module-1",
  "stack-module-10": "FullBleedCallout-module-scss-module__LnXdeq__stack-module-10",
  "stack-module-11": "FullBleedCallout-module-scss-module__LnXdeq__stack-module-11",
  "stack-module-12": "FullBleedCallout-module-scss-module__LnXdeq__stack-module-12",
  "stack-module-13": "FullBleedCallout-module-scss-module__LnXdeq__stack-module-13",
  "stack-module-14": "FullBleedCallout-module-scss-module__LnXdeq__stack-module-14",
  "stack-module-15": "FullBleedCallout-module-scss-module__LnXdeq__stack-module-15",
  "stack-module-16": "FullBleedCallout-module-scss-module__LnXdeq__stack-module-16",
  "stack-module-17": "FullBleedCallout-module-scss-module__LnXdeq__stack-module-17",
  "stack-module-18": "FullBleedCallout-module-scss-module__LnXdeq__stack-module-18",
  "stack-module-19": "FullBleedCallout-module-scss-module__LnXdeq__stack-module-19",
  "stack-module-2": "FullBleedCallout-module-scss-module__LnXdeq__stack-module-2",
  "stack-module-20": "FullBleedCallout-module-scss-module__LnXdeq__stack-module-20",
  "stack-module-3": "FullBleedCallout-module-scss-module__LnXdeq__stack-module-3",
  "stack-module-4": "FullBleedCallout-module-scss-module__LnXdeq__stack-module-4",
  "stack-module-5": "FullBleedCallout-module-scss-module__LnXdeq__stack-module-5",
  "stack-module-6": "FullBleedCallout-module-scss-module__LnXdeq__stack-module-6",
  "stack-module-7": "FullBleedCallout-module-scss-module__LnXdeq__stack-module-7",
  "stack-module-8": "FullBleedCallout-module-scss-module__LnXdeq__stack-module-8",
  "stack-module-9": "FullBleedCallout-module-scss-module__LnXdeq__stack-module-9",
  "z-base": "FullBleedCallout-module-scss-module__LnXdeq__z-base",
  "z-content": "FullBleedCallout-module-scss-module__LnXdeq__z-content",
  "z-footer": "FullBleedCallout-module-scss-module__LnXdeq__z-footer",
  "z-header": "FullBleedCallout-module-scss-module__LnXdeq__z-header",
  "z-hero": "FullBleedCallout-module-scss-module__LnXdeq__z-hero",
  "z-logo": "FullBleedCallout-module-scss-module__LnXdeq__z-logo",
  "z-logo-effect": "FullBleedCallout-module-scss-module__LnXdeq__z-logo-effect",
  "z-navigation": "FullBleedCallout-module-scss-module__LnXdeq__z-navigation",
  "z-sub": "FullBleedCallout-module-scss-module__LnXdeq__z-sub",
});
